import { IPaging } from "models/interfaces";
import React from "react";

type PROPS = {
  data: IPaging;
};

const PageLabel: React.FC<PROPS> = (props) => {
  const paging = props.data.paging;
  return (
    <div>
      全{paging.total_record}件
      {paging.show_record_from && (
        <>
          中{paging.show_record_from}~{paging.show_record_to}件を表示
        </>
      )}
    </div>
  );
};

export default PageLabel;
